import React, { useState } from 'react';
import RatingModal from './RatingModal';
import { CloseButton } from '../../../../../consumer-ui/src/common/components/Buttons/Buttons';
import { submitFeedback } from '../../constants/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import verified from '../../../../../consumer-ui/src/images/icons/verified.svg';
import verification_failed from '../../../../../consumer-ui/src/images/icons/verification_failed.svg';
import applicationRating from '../../../../../consumer-ui/src/images/icons/MyApplicationsIcons/applicationRating.svg';
import styles from './styles.module.css';
import { SuccessDes } from '../../components/PopUp/CommonSvgs';
import { useWindowResize } from '../../../hooks/useWindowResize';

const RatingIcon = (
  <FontAwesomeIcon icon={faStar} className="text-4xl md:text-5xl" />
);
const ratingOptions = [5, 4, 3, 2, 1];
const ratingTextOptions = {
  1: 'Very Bad',
  2: 'Bad',
  3: 'Average',
  4: 'Good',
  5: 'Very Good'
};

const SubmissionStatus = () => {
  const [success, setSuccess] = useState(true);
  const [cardOpen, setCardOpen] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  const { modalOpener, star } = styles;

  return (
    <div>
      {cardOpen ? (
        <div className="mx-auto p-6 bg-white relative">
          <div className="flex flex-row-reverse justify-start">
            <CloseButton onClick={() => setCardOpen(false)} />
          </div>

          <div className="flex flex-col justify-around items-center md:items-start">
            <div className="flex flex-col-reverse md:flex-row">
              <h3 className="text-lg xmd:text-xl xxl:text-2xl text-grey-600 font-semibold my-4">
                Your application is submitted successfully
              </h3>
              <div className="flex place-content-center block md:inline mx-auto md:ml-2.5  mt-1">
                <SuccessDes height={50} width={50} />
              </div>
            </div>
            <p className="text-xs md:text-sm xmd:text-base xxl:text-xl text-grey-600">
              Once your application is approved, we will let you know over you
              mail
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center mt-4">
            <div className="my-4">
              <p className="text-xs md:text-sm xmd:text-base xxl:text-xl text-grey-600 text-center md:text-left">
                Please rate your overall experience
              </p>
              <div
                className={`flex flex-row-reverse justify-center cursor-pointer my-4  space-x-4 space-x-reverse  ${modalOpener}`}
                onClick={() => setModalOpen(true)}
              >
                {ratingOptions.map(num => (
                  <span key={num} className={`${star}  `}>
                    {RatingIcon}
                  </span>
                ))}
              </div>
            </div>
            <img
              src={applicationRating}
              alt="Application Rating icon"
              className="hidden md:inline md:w-32 xmd:w-35 lg:w-56 xxl:w-72"
            />
          </div>

          {modalOpen && (
            <RatingModal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              ratingIcon={RatingIcon}
              ratingOptions={ratingOptions}
              ratingTextOptions={ratingTextOptions}
              submitFeedback={submitFeedback}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SubmissionStatus;
